<template>
  <div class="flex flex-row lab pointer" @click="labClick">
    <div class="lab-left">
      <img :src="data.laboratoryLogo" class="lab-icon" />
    </div>
    <div>
      <div class="lab-name">{{ data.laboratoryName }}</div>
      <div class="lab-tip address">地址：{{ data.laboratoryLocation }}</div>
      <div class="lab-tip">
        <span>联系人：{{ data.laboratoryContactsName }}</span>
        <span>电话：{{ data.laboratoryContactsPhone }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    labClick() {
      this.$jump.push({
        name: "labDetail",
        query: { id: this.data.resourceId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.lab {
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 20px;
  &-icon {
    width: 120px;
    height: 80px;
    object-fit: contain;
    border: 1px solid #f2f6fc;
  }
  &-left {
    margin-right: 20px;
  }
  &-name {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-tip {
    color: #909399;
    &.address {
      margin-bottom: 5px;
    }
  }
}
</style>
